"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_APPLE_STORE_COUNTRY = exports.DEFAULT_PHONE_INPUT_COUNTRY = exports.DEFAULT_ORGANIZATION_COUNTRY = exports.convertAnyToOrganizationCountry = exports.ORGANIZATION_COUNTRY_MAP = exports.GoogleMapCountryCode = exports.AppleStoreCountry = exports.PhoneInputCountry = exports.CountryCode = exports.CountryNames = exports.OrganizationCountry = void 0;
const currency_1 = require("./currency");
var OrganizationCountry;
(function (OrganizationCountry) {
    OrganizationCountry["Canada"] = "Canada";
    OrganizationCountry["UnitedStates"] = "UnitedStates";
    OrganizationCountry["GreatBritain"] = "GreatBritain";
    OrganizationCountry["Australia"] = "Australia";
    OrganizationCountry["NewZealand"] = "NewZealand";
    OrganizationCountry["Ireland"] = "Ireland";
    OrganizationCountry["Germany"] = "Germany";
})(OrganizationCountry || (exports.OrganizationCountry = OrganizationCountry = {}));
// Enum generated from country-region-data library
var CountryNames;
(function (CountryNames) {
    CountryNames["Afghanistan"] = "Afghanistan";
    CountryNames["AlandIslands"] = "\u00C5land Islands";
    CountryNames["Albania"] = "Albania";
    CountryNames["Algeria"] = "Algeria";
    CountryNames["AmericanSamoa"] = "American Samoa";
    CountryNames["Andorra"] = "Andorra";
    CountryNames["Angola"] = "Angola";
    CountryNames["Anguilla"] = "Anguilla";
    CountryNames["Antarctica"] = "Antarctica";
    CountryNames["AntiguaAndBarbuda"] = "Antigua and Barbuda";
    CountryNames["Argentina"] = "Argentina";
    CountryNames["Armenia"] = "Armenia";
    CountryNames["Aruba"] = "Aruba";
    CountryNames["Australia"] = "Australia";
    CountryNames["Austria"] = "Austria";
    CountryNames["Azerbaijan"] = "Azerbaijan";
    CountryNames["Bahamas"] = "Bahamas";
    CountryNames["Bahrain"] = "Bahrain";
    CountryNames["Bangladesh"] = "Bangladesh";
    CountryNames["Barbados"] = "Barbados";
    CountryNames["Belarus"] = "Belarus";
    CountryNames["Belgium"] = "Belgium";
    CountryNames["Belize"] = "Belize";
    CountryNames["Benin"] = "Benin";
    CountryNames["Bermuda"] = "Bermuda";
    CountryNames["Bhutan"] = "Bhutan";
    CountryNames["Bolivia"] = "Bolivia";
    CountryNames["BonaireSintEustatiusAndSaba"] = "Bonaire, Sint Eustatius and Saba";
    CountryNames["BosniaAndHerzegovina"] = "Bosnia and Herzegovina";
    CountryNames["Botswana"] = "Botswana";
    CountryNames["BouvetIsland"] = "Bouvet Island";
    CountryNames["Brazil"] = "Brazil";
    CountryNames["BritishIndianOceanTerritory"] = "British Indian Ocean Territory";
    CountryNames["BruneiDarussalam"] = "Brunei Darussalam";
    CountryNames["Bulgaria"] = "Bulgaria";
    CountryNames["BurkinaFaso"] = "Burkina Faso";
    CountryNames["Burundi"] = "Burundi";
    CountryNames["Cambodia"] = "Cambodia";
    CountryNames["Cameroon"] = "Cameroon";
    CountryNames["Canada"] = "Canada";
    CountryNames["CapeVerde"] = "Cape Verde";
    CountryNames["CaymanIslands"] = "Cayman Islands";
    CountryNames["CentralAfricanRepublic"] = "Central African Republic";
    CountryNames["Chad"] = "Chad";
    CountryNames["Chile"] = "Chile";
    CountryNames["China"] = "China";
    CountryNames["ChristmasIsland"] = "Christmas Island";
    CountryNames["CocosKeelingIslands"] = "Cocos (Keeling) Islands";
    CountryNames["Colombia"] = "Colombia";
    CountryNames["Comoros"] = "Comoros";
    CountryNames["CongoRepublicOfTheBrazzaville"] = "Congo, Republic of the (Brazzaville)";
    CountryNames["CongoTheDemocraticRepublicOfTheKinshasa"] = "Congo, the Democratic Republic of the (Kinshasa)";
    CountryNames["CookIslands"] = "Cook Islands";
    CountryNames["CostaRica"] = "Costa Rica";
    CountryNames["CoteDivoireRepublicOf"] = "C\u00F4te d'Ivoire, Republic of";
    CountryNames["Croatia"] = "Croatia";
    CountryNames["Cuba"] = "Cuba";
    CountryNames["Curacao"] = "Cura\u00E7ao";
    CountryNames["Cyprus"] = "Cyprus";
    CountryNames["CzechRepublic"] = "Czech Republic";
    CountryNames["Denmark"] = "Denmark";
    CountryNames["Djibouti"] = "Djibouti";
    CountryNames["Dominica"] = "Dominica";
    CountryNames["DominicanRepublic"] = "Dominican Republic";
    CountryNames["Ecuador"] = "Ecuador";
    CountryNames["Egypt"] = "Egypt";
    CountryNames["ElSalvador"] = "El Salvador";
    CountryNames["EquatorialGuinea"] = "Equatorial Guinea";
    CountryNames["Eritrea"] = "Eritrea";
    CountryNames["Estonia"] = "Estonia";
    CountryNames["Ethiopia"] = "Ethiopia";
    CountryNames["FalklandIslandsIslasMalvinas"] = "Falkland Islands (Islas Malvinas)";
    CountryNames["FaroeIslands"] = "Faroe Islands";
    CountryNames["Fiji"] = "Fiji";
    CountryNames["Finland"] = "Finland";
    CountryNames["France"] = "France";
    CountryNames["FrenchGuiana"] = "French Guiana";
    CountryNames["FrenchPolynesia"] = "French Polynesia";
    CountryNames["FrenchSouthernAndAntarcticLands"] = "French Southern and Antarctic Lands";
    CountryNames["Gabon"] = "Gabon";
    CountryNames["GambiaThe"] = "Gambia, The";
    CountryNames["Georgia"] = "Georgia";
    CountryNames["Germany"] = "Germany";
    CountryNames["Ghana"] = "Ghana";
    CountryNames["Gibraltar"] = "Gibraltar";
    CountryNames["Greece"] = "Greece";
    CountryNames["Greenland"] = "Greenland";
    CountryNames["Grenada"] = "Grenada";
    CountryNames["Guadeloupe"] = "Guadeloupe";
    CountryNames["Guam"] = "Guam";
    CountryNames["Guatemala"] = "Guatemala";
    CountryNames["Guernsey"] = "Guernsey";
    CountryNames["Guinea"] = "Guinea";
    CountryNames["GuineaBissau"] = "Guinea-Bissau";
    CountryNames["Guyana"] = "Guyana";
    CountryNames["Haiti"] = "Haiti";
    CountryNames["HeardIslandAndMcdonaldIslands"] = "Heard Island and McDonald Islands";
    CountryNames["HolySeeVaticanCity"] = "Holy See (Vatican City)";
    CountryNames["Honduras"] = "Honduras";
    CountryNames["HongKong"] = "Hong Kong";
    CountryNames["Hungary"] = "Hungary";
    CountryNames["Iceland"] = "Iceland";
    CountryNames["India"] = "India";
    CountryNames["Indonesia"] = "Indonesia";
    CountryNames["IranIslamicRepublicOf"] = "Iran, Islamic Republic of";
    CountryNames["Iraq"] = "Iraq";
    CountryNames["Ireland"] = "Ireland";
    CountryNames["IsleOfMan"] = "Isle of Man";
    CountryNames["Israel"] = "Israel";
    CountryNames["Italy"] = "Italy";
    CountryNames["Jamaica"] = "Jamaica";
    CountryNames["Japan"] = "Japan";
    CountryNames["Jersey"] = "Jersey";
    CountryNames["Jordan"] = "Jordan";
    CountryNames["Kazakhstan"] = "Kazakhstan";
    CountryNames["Kenya"] = "Kenya";
    CountryNames["Kiribati"] = "Kiribati";
    CountryNames["KoreaDemocraticPeoplesRepublicOf"] = "Korea, Democratic People's Republic of";
    CountryNames["KoreaRepublicOf"] = "Korea, Republic of";
    CountryNames["Kosovo"] = "Kosovo";
    CountryNames["Kuwait"] = "Kuwait";
    CountryNames["Kyrgyzstan"] = "Kyrgyzstan";
    CountryNames["Laos"] = "Laos";
    CountryNames["Latvia"] = "Latvia";
    CountryNames["Lebanon"] = "Lebanon";
    CountryNames["Lesotho"] = "Lesotho";
    CountryNames["Liberia"] = "Liberia";
    CountryNames["Libya"] = "Libya";
    CountryNames["Liechtenstein"] = "Liechtenstein";
    CountryNames["Lithuania"] = "Lithuania";
    CountryNames["Luxembourg"] = "Luxembourg";
    CountryNames["Macao"] = "Macao";
    CountryNames["MacedoniaRepublicOf"] = "Macedonia, Republic of";
    CountryNames["Madagascar"] = "Madagascar";
    CountryNames["Malawi"] = "Malawi";
    CountryNames["Malaysia"] = "Malaysia";
    CountryNames["Maldives"] = "Maldives";
    CountryNames["Mali"] = "Mali";
    CountryNames["Malta"] = "Malta";
    CountryNames["MarshallIslands"] = "Marshall Islands";
    CountryNames["Martinique"] = "Martinique";
    CountryNames["Mauritania"] = "Mauritania";
    CountryNames["Mauritius"] = "Mauritius";
    CountryNames["Mayotte"] = "Mayotte";
    CountryNames["Mexico"] = "Mexico";
    CountryNames["MicronesiaFederatedStatesOf"] = "Micronesia, Federated States of";
    CountryNames["Moldova"] = "Moldova";
    CountryNames["Monaco"] = "Monaco";
    CountryNames["Mongolia"] = "Mongolia";
    CountryNames["Montenegro"] = "Montenegro";
    CountryNames["Montserrat"] = "Montserrat";
    CountryNames["Morocco"] = "Morocco";
    CountryNames["Mozambique"] = "Mozambique";
    CountryNames["Myanmar"] = "Myanmar";
    CountryNames["Namibia"] = "Namibia";
    CountryNames["Nauru"] = "Nauru";
    CountryNames["Nepal"] = "Nepal";
    CountryNames["Netherlands"] = "Netherlands";
    CountryNames["NewCaledonia"] = "New Caledonia";
    CountryNames["NewZealand"] = "New Zealand";
    CountryNames["Nicaragua"] = "Nicaragua";
    CountryNames["Niger"] = "Niger";
    CountryNames["Nigeria"] = "Nigeria";
    CountryNames["Niue"] = "Niue";
    CountryNames["NorfolkIsland"] = "Norfolk Island";
    CountryNames["NorthernMarianaIslands"] = "Northern Mariana Islands";
    CountryNames["Norway"] = "Norway";
    CountryNames["Oman"] = "Oman";
    CountryNames["Pakistan"] = "Pakistan";
    CountryNames["Palau"] = "Palau";
    CountryNames["PalestineStateOf"] = "Palestine, State of";
    CountryNames["Panama"] = "Panama";
    CountryNames["PapuaNewGuinea"] = "Papua New Guinea";
    CountryNames["Paraguay"] = "Paraguay";
    CountryNames["Peru"] = "Peru";
    CountryNames["Philippines"] = "Philippines";
    CountryNames["Pitcairn"] = "Pitcairn";
    CountryNames["Poland"] = "Poland";
    CountryNames["Portugal"] = "Portugal";
    CountryNames["PuertoRico"] = "Puerto Rico";
    CountryNames["Qatar"] = "Qatar";
    CountryNames["Reunion"] = "R\u00E9union";
    CountryNames["Romania"] = "Romania";
    CountryNames["RussianFederation"] = "Russian Federation";
    CountryNames["Rwanda"] = "Rwanda";
    CountryNames["SaintBarthelemy"] = "Saint Barth\u00E9lemy";
    CountryNames["SaintHelenaAscensionAndTristanDaCunha"] = "Saint Helena, Ascension and Tristan da Cunha";
    CountryNames["SaintKittsAndNevis"] = "Saint Kitts and Nevis";
    CountryNames["SaintLucia"] = "Saint Lucia";
    CountryNames["SaintMartin"] = "Saint Martin";
    CountryNames["SaintPierreAndMiquelon"] = "Saint Pierre and Miquelon";
    CountryNames["SaintVincentAndTheGrenadines"] = "Saint Vincent and the Grenadines";
    CountryNames["Samoa"] = "Samoa";
    CountryNames["SanMarino"] = "San Marino";
    CountryNames["SaoTomeAndPrincipe"] = "Sao Tome and Principe";
    CountryNames["SaudiArabia"] = "Saudi Arabia";
    CountryNames["Senegal"] = "Senegal";
    CountryNames["Serbia"] = "Serbia";
    CountryNames["Seychelles"] = "Seychelles";
    CountryNames["SierraLeone"] = "Sierra Leone";
    CountryNames["Singapore"] = "Singapore";
    CountryNames["SintMaartenDutchPart"] = "Sint Maarten (Dutch part)";
    CountryNames["Slovakia"] = "Slovakia";
    CountryNames["Slovenia"] = "Slovenia";
    CountryNames["SolomonIslands"] = "Solomon Islands";
    CountryNames["Somalia"] = "Somalia";
    CountryNames["SouthAfrica"] = "South Africa";
    CountryNames["SouthGeorgiaAndSouthSandwichIslands"] = "South Georgia and South Sandwich Islands";
    CountryNames["SouthSudan"] = "South Sudan";
    CountryNames["Spain"] = "Spain";
    CountryNames["SriLanka"] = "Sri Lanka";
    CountryNames["Sudan"] = "Sudan";
    CountryNames["Suriname"] = "Suriname";
    CountryNames["Swaziland"] = "Swaziland";
    CountryNames["Sweden"] = "Sweden";
    CountryNames["Switzerland"] = "Switzerland";
    CountryNames["SyrianArabRepublic"] = "Syrian Arab Republic";
    CountryNames["Taiwan"] = "Taiwan";
    CountryNames["Tajikistan"] = "Tajikistan";
    CountryNames["TanzaniaUnitedRepublicOf"] = "Tanzania, United Republic of";
    CountryNames["Thailand"] = "Thailand";
    CountryNames["TimorLeste"] = "Timor-Leste";
    CountryNames["Togo"] = "Togo";
    CountryNames["Tokelau"] = "Tokelau";
    CountryNames["Tonga"] = "Tonga";
    CountryNames["TrinidadAndTobago"] = "Trinidad and Tobago";
    CountryNames["Tunisia"] = "Tunisia";
    CountryNames["Turkey"] = "Turkey";
    CountryNames["Turkmenistan"] = "Turkmenistan";
    CountryNames["TurksAndCaicosIslands"] = "Turks and Caicos Islands";
    CountryNames["Tuvalu"] = "Tuvalu";
    CountryNames["Uganda"] = "Uganda";
    CountryNames["Ukraine"] = "Ukraine";
    CountryNames["UnitedArabEmirates"] = "United Arab Emirates";
    CountryNames["UnitedKingdom"] = "United Kingdom";
    CountryNames["UnitedStates"] = "United States";
    CountryNames["UnitedStatesMinorOutlyingIslands"] = "United States Minor Outlying Islands";
    CountryNames["Uruguay"] = "Uruguay";
    CountryNames["Uzbekistan"] = "Uzbekistan";
    CountryNames["Vanuatu"] = "Vanuatu";
    CountryNames["VenezuelaBolivarianRepublicOf"] = "Venezuela, Bolivarian Republic of";
    CountryNames["Vietnam"] = "Vietnam";
    CountryNames["VirginIslandsBritish"] = "Virgin Islands, British";
    CountryNames["VirginIslandsUs"] = "Virgin Islands, U.S.";
    CountryNames["WallisAndFutuna"] = "Wallis and Futuna";
    CountryNames["WesternSahara"] = "Western Sahara";
    CountryNames["Yemen"] = "Yemen";
    CountryNames["Zambia"] = "Zambia";
    CountryNames["Zimbabwe"] = "Zimbabwe";
})(CountryNames || (exports.CountryNames = CountryNames = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["AD"] = "AD";
    CountryCode["AE"] = "AE";
    CountryCode["AF"] = "AF";
    CountryCode["AG"] = "AG";
    CountryCode["AI"] = "AI";
    CountryCode["AL"] = "AL";
    CountryCode["AM"] = "AM";
    CountryCode["AO"] = "AO";
    CountryCode["AQ"] = "AQ";
    CountryCode["AR"] = "AR";
    CountryCode["AS"] = "AS";
    CountryCode["AT"] = "AT";
    CountryCode["AU"] = "AU";
    CountryCode["AW"] = "AW";
    CountryCode["AX"] = "AX";
    CountryCode["AZ"] = "AZ";
    CountryCode["BA"] = "BA";
    CountryCode["BB"] = "BB";
    CountryCode["BD"] = "BD";
    CountryCode["BE"] = "BE";
    CountryCode["BF"] = "BF";
    CountryCode["BG"] = "BG";
    CountryCode["BH"] = "BH";
    CountryCode["BI"] = "BI";
    CountryCode["BJ"] = "BJ";
    CountryCode["BL"] = "BL";
    CountryCode["BM"] = "BM";
    CountryCode["BN"] = "BN";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BR"] = "BR";
    CountryCode["BS"] = "BS";
    CountryCode["BT"] = "BT";
    CountryCode["BV"] = "BV";
    CountryCode["BW"] = "BW";
    CountryCode["BY"] = "BY";
    CountryCode["BZ"] = "BZ";
    CountryCode["CA"] = "CA";
    CountryCode["CC"] = "CC";
    CountryCode["CD"] = "CD";
    CountryCode["CF"] = "CF";
    CountryCode["CG"] = "CG";
    CountryCode["CH"] = "CH";
    CountryCode["CI"] = "CI";
    CountryCode["CK"] = "CK";
    CountryCode["CL"] = "CL";
    CountryCode["CM"] = "CM";
    CountryCode["CN"] = "CN";
    CountryCode["CO"] = "CO";
    CountryCode["CR"] = "CR";
    CountryCode["CU"] = "CU";
    CountryCode["CV"] = "CV";
    CountryCode["CW"] = "CW";
    CountryCode["CX"] = "CX";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DE"] = "DE";
    CountryCode["DJ"] = "DJ";
    CountryCode["DK"] = "DK";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["DZ"] = "DZ";
    CountryCode["EC"] = "EC";
    CountryCode["EE"] = "EE";
    CountryCode["EG"] = "EG";
    CountryCode["EH"] = "EH";
    CountryCode["ER"] = "ER";
    CountryCode["ES"] = "ES";
    CountryCode["ET"] = "ET";
    CountryCode["FI"] = "FI";
    CountryCode["FJ"] = "FJ";
    CountryCode["FK"] = "FK";
    CountryCode["FM"] = "FM";
    CountryCode["FO"] = "FO";
    CountryCode["FR"] = "FR";
    CountryCode["GA"] = "GA";
    CountryCode["GB"] = "GB";
    CountryCode["GD"] = "GD";
    CountryCode["GE"] = "GE";
    CountryCode["GF"] = "GF";
    CountryCode["GG"] = "GG";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GL"] = "GL";
    CountryCode["GM"] = "GM";
    CountryCode["GN"] = "GN";
    CountryCode["GP"] = "GP";
    CountryCode["GQ"] = "GQ";
    CountryCode["GR"] = "GR";
    CountryCode["GS"] = "GS";
    CountryCode["GT"] = "GT";
    CountryCode["GU"] = "GU";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HK"] = "HK";
    CountryCode["HM"] = "HM";
    CountryCode["HN"] = "HN";
    CountryCode["HR"] = "HR";
    CountryCode["HT"] = "HT";
    CountryCode["HU"] = "HU";
    CountryCode["ID"] = "ID";
    CountryCode["IE"] = "IE";
    CountryCode["IL"] = "IL";
    CountryCode["IM"] = "IM";
    CountryCode["IN"] = "IN";
    CountryCode["IO"] = "IO";
    CountryCode["IQ"] = "IQ";
    CountryCode["IR"] = "IR";
    CountryCode["IS"] = "IS";
    CountryCode["IT"] = "IT";
    CountryCode["JE"] = "JE";
    CountryCode["JM"] = "JM";
    CountryCode["JO"] = "JO";
    CountryCode["JP"] = "JP";
    CountryCode["KE"] = "KE";
    CountryCode["KG"] = "KG";
    CountryCode["KH"] = "KH";
    CountryCode["KI"] = "KI";
    CountryCode["KM"] = "KM";
    CountryCode["KN"] = "KN";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KY"] = "KY";
    CountryCode["KZ"] = "KZ";
    CountryCode["LA"] = "LA";
    CountryCode["LB"] = "LB";
    CountryCode["LC"] = "LC";
    CountryCode["LI"] = "LI";
    CountryCode["LK"] = "LK";
    CountryCode["LR"] = "LR";
    CountryCode["LS"] = "LS";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["LV"] = "LV";
    CountryCode["LY"] = "LY";
    CountryCode["MA"] = "MA";
    CountryCode["MC"] = "MC";
    CountryCode["MD"] = "MD";
    CountryCode["ME"] = "ME";
    CountryCode["MF"] = "MF";
    CountryCode["MG"] = "MG";
    CountryCode["MH"] = "MH";
    CountryCode["MK"] = "MK";
    CountryCode["ML"] = "ML";
    CountryCode["MM"] = "MM";
    CountryCode["MN"] = "MN";
    CountryCode["MO"] = "MO";
    CountryCode["MP"] = "MP";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MS"] = "MS";
    CountryCode["MT"] = "MT";
    CountryCode["MU"] = "MU";
    CountryCode["MV"] = "MV";
    CountryCode["MW"] = "MW";
    CountryCode["MX"] = "MX";
    CountryCode["MY"] = "MY";
    CountryCode["MZ"] = "MZ";
    CountryCode["NA"] = "NA";
    CountryCode["NC"] = "NC";
    CountryCode["NE"] = "NE";
    CountryCode["NF"] = "NF";
    CountryCode["NG"] = "NG";
    CountryCode["NI"] = "NI";
    CountryCode["NL"] = "NL";
    CountryCode["NO"] = "NO";
    CountryCode["NP"] = "NP";
    CountryCode["NR"] = "NR";
    CountryCode["NU"] = "NU";
    CountryCode["NZ"] = "NZ";
    CountryCode["OM"] = "OM";
    CountryCode["PA"] = "PA";
    CountryCode["PE"] = "PE";
    CountryCode["PF"] = "PF";
    CountryCode["PG"] = "PG";
    CountryCode["PH"] = "PH";
    CountryCode["PK"] = "PK";
    CountryCode["PL"] = "PL";
    CountryCode["PM"] = "PM";
    CountryCode["PN"] = "PN";
    CountryCode["PR"] = "PR";
    CountryCode["PS"] = "PS";
    CountryCode["PT"] = "PT";
    CountryCode["PW"] = "PW";
    CountryCode["PY"] = "PY";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RS"] = "RS";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["SA"] = "SA";
    CountryCode["SB"] = "SB";
    CountryCode["SC"] = "SC";
    CountryCode["SD"] = "SD";
    CountryCode["SE"] = "SE";
    CountryCode["SG"] = "SG";
    CountryCode["SH"] = "SH";
    CountryCode["SI"] = "SI";
    CountryCode["SJ"] = "SJ";
    CountryCode["SK"] = "SK";
    CountryCode["SL"] = "SL";
    CountryCode["SM"] = "SM";
    CountryCode["SN"] = "SN";
    CountryCode["SO"] = "SO";
    CountryCode["SR"] = "SR";
    CountryCode["SS"] = "SS";
    CountryCode["ST"] = "ST";
    CountryCode["SV"] = "SV";
    CountryCode["SX"] = "SX";
    CountryCode["SY"] = "SY";
    CountryCode["SZ"] = "SZ";
    CountryCode["TC"] = "TC";
    CountryCode["TD"] = "TD";
    CountryCode["TF"] = "TF";
    CountryCode["TG"] = "TG";
    CountryCode["TH"] = "TH";
    CountryCode["TJ"] = "TJ";
    CountryCode["TK"] = "TK";
    CountryCode["TL"] = "TL";
    CountryCode["TM"] = "TM";
    CountryCode["TN"] = "TN";
    CountryCode["TO"] = "TO";
    CountryCode["TR"] = "TR";
    CountryCode["TT"] = "TT";
    CountryCode["TV"] = "TV";
    CountryCode["TW"] = "TW";
    CountryCode["TZ"] = "TZ";
    CountryCode["UA"] = "UA";
    CountryCode["UG"] = "UG";
    CountryCode["UM"] = "UM";
    CountryCode["US"] = "US";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VA"] = "VA";
    CountryCode["VC"] = "VC";
    CountryCode["VE"] = "VE";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["VN"] = "VN";
    CountryCode["VU"] = "VU";
    CountryCode["WF"] = "WF";
    CountryCode["WS"] = "WS";
    CountryCode["XK"] = "XK";
    CountryCode["YE"] = "YE";
    CountryCode["YT"] = "YT";
    CountryCode["ZA"] = "ZA";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
var PhoneInputCountry;
(function (PhoneInputCountry) {
    PhoneInputCountry["CA"] = "ca";
    PhoneInputCountry["US"] = "us";
    PhoneInputCountry["GB"] = "gb";
    PhoneInputCountry["AU"] = "au";
    PhoneInputCountry["NZ"] = "nz";
    PhoneInputCountry["IE"] = "ie";
    PhoneInputCountry["DE"] = "de";
})(PhoneInputCountry || (exports.PhoneInputCountry = PhoneInputCountry = {}));
var AppleStoreCountry;
(function (AppleStoreCountry) {
    AppleStoreCountry["CA"] = "ca";
    AppleStoreCountry["US"] = "us";
    AppleStoreCountry["GB"] = "gb";
    AppleStoreCountry["AU"] = "au";
    AppleStoreCountry["NZ"] = "nz";
    AppleStoreCountry["IE"] = "ie";
    AppleStoreCountry["DE"] = "de";
})(AppleStoreCountry || (exports.AppleStoreCountry = AppleStoreCountry = {}));
var GoogleMapCountryCode;
(function (GoogleMapCountryCode) {
    GoogleMapCountryCode["CA"] = "ca";
    GoogleMapCountryCode["US"] = "us";
    GoogleMapCountryCode["GB"] = "gb";
    GoogleMapCountryCode["AU"] = "au";
    GoogleMapCountryCode["NZ"] = "nz";
    GoogleMapCountryCode["IE"] = "ie";
    GoogleMapCountryCode["DE"] = "de";
})(GoogleMapCountryCode || (exports.GoogleMapCountryCode = GoogleMapCountryCode = {}));
exports.ORGANIZATION_COUNTRY_MAP = {
    [OrganizationCountry.Canada]: {
        countryCode: CountryCode.CA,
        countryName: CountryNames.Canada,
        phoneInputCountry: PhoneInputCountry.CA,
        currency: currency_1.AvailablePaymentCurrency.Cad,
        appleStoreCountry: AppleStoreCountry.CA,
        googleMapCountryCode: GoogleMapCountryCode.CA,
    },
    [OrganizationCountry.UnitedStates]: {
        countryCode: CountryCode.US,
        countryName: CountryNames.UnitedStates,
        phoneInputCountry: PhoneInputCountry.US,
        currency: currency_1.AvailablePaymentCurrency.Usd,
        appleStoreCountry: AppleStoreCountry.US,
        googleMapCountryCode: GoogleMapCountryCode.US,
    },
    [OrganizationCountry.GreatBritain]: {
        countryCode: CountryCode.GB,
        countryName: CountryNames.UnitedKingdom,
        phoneInputCountry: PhoneInputCountry.GB,
        currency: currency_1.AvailablePaymentCurrency.Gbp,
        appleStoreCountry: AppleStoreCountry.GB,
        googleMapCountryCode: GoogleMapCountryCode.GB,
    },
    [OrganizationCountry.Australia]: {
        countryCode: CountryCode.AU,
        countryName: CountryNames.Australia,
        phoneInputCountry: PhoneInputCountry.AU,
        currency: currency_1.AvailablePaymentCurrency.Aud,
        appleStoreCountry: AppleStoreCountry.AU,
        googleMapCountryCode: GoogleMapCountryCode.AU,
    },
    [OrganizationCountry.NewZealand]: {
        countryCode: CountryCode.NZ,
        countryName: CountryNames.NewZealand,
        phoneInputCountry: PhoneInputCountry.NZ,
        currency: currency_1.AvailablePaymentCurrency.Nzd,
        appleStoreCountry: AppleStoreCountry.NZ,
        googleMapCountryCode: GoogleMapCountryCode.NZ,
    },
    [OrganizationCountry.Ireland]: {
        countryCode: CountryCode.IE,
        countryName: CountryNames.Ireland,
        phoneInputCountry: PhoneInputCountry.IE,
        currency: currency_1.AvailablePaymentCurrency.Eur,
        appleStoreCountry: AppleStoreCountry.IE,
        googleMapCountryCode: GoogleMapCountryCode.IE,
    },
    [OrganizationCountry.Germany]: {
        countryCode: CountryCode.DE,
        countryName: CountryNames.Germany,
        phoneInputCountry: PhoneInputCountry.DE,
        currency: currency_1.AvailablePaymentCurrency.Eur,
        appleStoreCountry: AppleStoreCountry.DE,
        googleMapCountryCode: GoogleMapCountryCode.DE,
    },
};
const convertAnyToOrganizationCountry = (value) => {
    const entry = Object.entries(exports.ORGANIZATION_COUNTRY_MAP).find(([, mapping]) => Object.values(mapping).includes(value));
    return entry ? entry[0] : undefined;
};
exports.convertAnyToOrganizationCountry = convertAnyToOrganizationCountry;
// Default values
exports.DEFAULT_ORGANIZATION_COUNTRY = OrganizationCountry.Canada;
exports.DEFAULT_PHONE_INPUT_COUNTRY = PhoneInputCountry.US;
exports.DEFAULT_APPLE_STORE_COUNTRY = AppleStoreCountry.US;
